<template>
  <div>
    <!-- 二维码 -->
    <div v-if="!$store.state.app.isPortrait">
      <div class="qrcode m-b-8">
        <template class="qrcode-item">
          <el-image
            v-if="qrcodeUrl"
            class="qrcodeImg"
            :src="qrcodeUrl"
            :preview-src-list="[qrcodeUrl]"
            @click="handleClickItem"
            >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <div class="text">
            <template v-if="!description">
              <img
                v-if="buildInfo.buildType === '1'"
                src="/images/preloader/logo-header.png"
                alt=""
                class="m-b-8"
              />
              <img
                v-else
                src="/images/preloader/logo-header2.png"
                alt=""
                class="m-b-8"
              />
            </template>
            <div v-if="description" class="remark">
              <span v-html="formatN(description)"></span>
            </div>
            <div v-else class="remark">
              欢迎扫码使用
              <br />{{ (buildInfo.buildType === "1" ? "医" : "易") + "路航小程序" }}
            </div>
          </div>
        </template>
      </div>
      <div v-if="ercodeObj.qrCodeFirst" class="qrcode m-b-8">
        <template class="qrcode-item fasfa12312321">
          <el-image
            class="qrcodeImg"
            :src="qiniuBaseUrl+ercodeObj.qrCodeFirst"
            :preview-src-list="[qiniuBaseUrl+ercodeObj.qrCodeFirst]"
            @click="handleClickItem"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <div class="text">
            <div class="remark">
              <span v-html="formatN(ercodeObj.qrCodeFirstRemark)"></span>
            </div>
          </div>
        </template>
      </div>
      <div v-if="ercodeObj.qrCodeSecond" class="qrcode m-b-8">
        <template class="qrcode-item">
          <el-image
            class="qrcodeImg"
            :src="qiniuBaseUrl+ercodeObj.qrCodeSecond"
            :preview-src-list="[qiniuBaseUrl+ercodeObj.qrCodeSecond]"
            @click="handleClickItem"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <div class="text">
            <div class="remark">
              <span v-html="formatN(ercodeObj.qrCodeSecondRemark)"></span>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div v-else class="qrcode">
      <template>
        <div class="qrcode-item">
          <el-image
            v-if="qrcodeUrl"
            class="qrcodeImg"
            :src="qrcodeUrl"
            :preview-src-list="[qrcodeUrl]"
            @click="handleClickItem"
            >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <div class="text">
            <template v-if="!description">
              <img
                v-if="buildInfo.buildType === '1'"
                src="/images/preloader/logo-header.png"
                alt=""
                class="m-b-8"
              />
              <img
                v-else
                src="/images/preloader/logo-header2.png"
                alt=""
                class="m-b-8"
              />
            </template>
            <div v-if="description" class="remark">
              <span v-html="formatN(description)"></span>
            </div>
            <div v-else class="remark">
              欢迎扫码使用
              <br />{{ (buildInfo.buildType === "1" ? "医" : "易") + "路航小程序" }}
            </div>
          </div>
        </div>
        <div v-if="ercodeObj.qrCodeFirst" class="qrcode-item">
          <el-image
            class="qrcodeImg"
            :src="qiniuBaseUrl+ercodeObj.qrCodeFirst"
            :preview-src-list="[qiniuBaseUrl+ercodeObj.qrCodeFirst]"
            @click="handleClickItem"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <div class="text">
            <div class="remark">
              <span v-html="formatN(ercodeObj.qrCodeFirstRemark)"></span>
            </div>
          </div>
        </div>
        <div v-if="ercodeObj.qrCodeSecond" class="qrcode-item">
          <el-image
            class="qrcodeImg"
            :src="qiniuBaseUrl+ercodeObj.qrCodeSecond"
            :preview-src-list="[qiniuBaseUrl+ercodeObj.qrCodeSecond]"
            @click="handleClickItem"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <div class="text">
            <div class="remark">
              <span v-html="formatN(ercodeObj.qrCodeSecondRemark)"></span>
            </div>
          </div>
        </div>
      </template>
      <div v-if="!showCopyRight" class="logo">
        ©2022 广东信尚安物联科技有限公司版权所有
      </div>
    </div>
    <div class="qrcodeImg" style="display: none;" ref="qrCodeUrl"></div>
</div>
</template>
<script>
import { getLocalStorage } from '@/utils/auth'
import QRCode from 'qrcodejs2'
export default {
  components: {
  },
  data () {
    return {
      isShowCopyRight: 1,
      ercodeObj: {},
      description: null,
      text: '',
      qrcodeUrl: ''
    };
  },
  computed: {
    // 七牛图片地址
    qiniuBaseUrl () {
      return this.$store.state.app.qiniuBaseUrl;
    },
    // 建筑信息
    buildInfo: {
      get () {
        return this.$store.state.nav.buildInfo;
      },
      set (val) {
        this.$store.commit('nav/set_buildInfo', val);
      }
    },
    showCopyRight () {
      return this.isShowCopyRight;
    },
    envCode () {
      return getLocalStorage('envCode') ? getLocalStorage('envCode') : '0'
    }
  },
  async mounted () {
    console.log('QRCode', QRCode);
    await this.getBaseSettingInfo();
    this.text = `${process.env.VUE_APP_QRCODE_URL}?mpbt=${this.buildInfo.buildType}&buildId=${this.buildInfo.buildId}&e=${this.envCode}`
    await this.creatQrCode(this.$refs.qrCodeUrl);
    setTimeout(() => {
        this.qrcodeUrl = this.$refs.qrCodeUrl.children[0].toDataURL('image/png')
        console.log('qrcodeUrl', this.qrcodeUrl);
    }, 10);
  },
  methods: {
    creatQrCode(ref) {
      if (ref) {
        ref.innerHTML = '';
        new QRCode(ref, {
          text: this.text, // 转换为二维码的内容
          width: 500,
          height: 500,
          colorDark: '#00423c',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        });
      }
      return 
    },
    formatN (str) {
      if (!str) return '';
      // console.log(JSON.stringify(str.replace('\n', '</br>')));
      return str.replaceAll('\n', '</br>');
    },
    async getBaseSettingInfo () {
      if (this.buildInfo.buildId) {
        try {
          let res = await this.$apis.app.getBaseSettingInfo({ buildId: this.buildInfo.buildId });
          console.log('resresresresres', res);
          if (res.data.basiSetting) {
            this.isShowCopyRight = res.data.basiSetting.isShowCopyRight;
            const { qrCodeFirst, qrCodeSecond, qrCodeFirstRemark, qrCodeSecondRemark } = res.data.basiSetting;
            this.ercodeObj = { qrCodeFirst, qrCodeSecond, qrCodeFirstRemark, qrCodeSecondRemark };
            console.log(res.data.basiSetting, 'res.data.basiSetting----');
            if (res.data.basiSetting.description) {
              this.description = res.data.basiSetting.description || null;
            }
          }
        } catch (error) {
          console.error('getBaseSettingInfo', error);
          return {};
        }
      }
    },
    // 关闭el-image遮罩层
    handleClickItem () {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask');
        if (!domImageMask) {
          return;
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click();
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@media (orientation: landscape) {
  .qrcode {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 22px;
    border: 1px solid #3a546e;
    border-radius: 20px;
    ::v-deep .el-icon-circle-close {
      color: #fff;
    }
    .qrcodeImg {
      margin-right: 30px;
      // width: 110px;
      border-radius: 10px;
      max-width: 40%;
    }
    .text {
      max-width: 45%;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: $color-white;
      font-size: 16px;
      line-height: 39px;
      img {
        height: 30px;
      }
      span{
        line-height: 24px;
        display: inline-block;
            /* 多行显示省略号 */
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 5;     //行数
        display: -webkit-box;
        overflow: hidden;
        color: $color-white;
        word-break: break-all;
      }
    }
  }
  .logo {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 20px;
    margin: auto;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.5);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 40px;
  }
  @media screen and (max-width: 1446px) {
    .qrcode {
      padding: 10px !important;
      .qrcodeImg {
        height: auto !important;
        width: 200px !important;
        margin-right: 20px !important;
        border-radius: 15px !important;
      }
      .text {
        font-size: 16px !important;
        line-height: 39px !important;
        img {
          height: 40px;
        }
        // margin: 0 0 0 35px;
      }
    }
  }
}
@media (orientation: portrait) {
  .qrcode {
    position: relative;
    width: 94.07vw;
    height: 23.52vw;
    margin: 2.22vw 2.96vw 2.22vw;
    background: $color-opacity-primary;
    display: flex;
    // align-items: center;
    border: 1px solid #3a546e;
    border-radius: 1.48vw;
    padding: 2.96vw;
    box-sizing: border-box;
    justify-content: space-around;
    ::v-deep .el-icon-circle-close {
      color: #fff;
    }
    .qrcodeImg {
      margin-right: 28px;
      height: 242px;
      border-radius: 10px;
      min-width: 45%;
      width: 45%;
    }
    .text {
      max-width: 40%;
      font-size: 36px;
      img {
        width: 256px;
        // height: 60px;
      }
      .remark {
        color: $color-white;
        text-align: left;
        margin-top: 12px;
      }
      span{
        line-height: 44px;
        display: inline-block;
            /* 多行显示省略号 */
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 5;     //行数
        display: -webkit-box;
        overflow: hidden;
        color: $color-white;
        word-break: break-all;
      }
    }
  }
  .qrcode-item{
    width: 33.33%;
    display: flex;
    // margin-right: 60px;
  }
  .logo {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 58px;
    margin: auto;
    font-size: 28px;
    color: rgba(255, 255, 255,1);
    height: 40px;
    line-height: 40px;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    // padding: 0 40px;
  }
}
.m-b-8 {
  margin-bottom: 8px;
}
</style>
